import { createReduxModule } from "hooks-for-redux";

export type RegisterStep = "form" | "username" | "socialUsername" | "joined";

const initialState = {
  willCreateAccountType: null,
  guestUsername: null,
  guestElo: null,
  token: null,
  progressKey: null,
  // Form state
  username: "",
  email: "",
  password: "",
  news: 0,
  step: "form" as RegisterStep,
  signedUpWithEmail: false,
  socialToken: null as string | null,
  socialAccountType: null as "facebook" | "apple" | "google" | null,
  usernameError: null as string | null,
  emailError: null as string | null,
  passwordError: null as string | null,
};

const [
  useRegister,
  {
    guestRegister,
    willCreateAccountType,
    setProgressKey,
    setUsername,
    setEmail,
    setPassword,
    setNews,
    setStep,
    setSignedUpWithEmail,
    setSocialToken,
    setSocialAccountType,
    setUsernameError,
    setEmailError,
    setPasswordError,
    resetForm,
  },
] = createReduxModule("register", initialState, {
  guestRegister: (state, { username, elo }) => ({
    ...state,
    guestUsername: username,
    guestElo: elo,
  }),
  willCreateAccountType: (state, { accountType, token }) => ({
    ...state,
    willCreateAccountType: accountType,
    token,
  }),
  setProgressKey: (state, progressKey) => ({
    ...state,
    progressKey,
  }),
  setUsername: (state, username) => ({
    ...state,
    username,
  }),
  setEmail: (state, email) => ({
    ...state,
    email,
  }),
  setPassword: (state, password) => ({
    ...state,
    password,
  }),
  setNews: (state, news) => ({
    ...state,
    news,
  }),
  setStep: (state, step: RegisterStep) => ({
    ...state,
    step,
  }),
  setSignedUpWithEmail: (state, signedUpWithEmail) => ({
    ...state,
    signedUpWithEmail,
  }),
  setSocialToken: (state, socialToken: string | null) => ({
    ...state,
    socialToken,
  }),
  setSocialAccountType: (
    state,
    socialAccountType: "facebook" | "apple" | "google" | null
  ) => ({
    ...state,
    socialAccountType,
  }),
  setUsernameError: (state, usernameError: string | null) => ({
    ...state,
    usernameError,
  }),
  setEmailError: (state, emailError: string | null) => ({
    ...state,
    emailError,
  }),
  setPasswordError: (state, passwordError: string | null) => ({
    ...state,
    passwordError,
  }),
  resetForm: (state) => ({
    ...state,
    username: "",
    email: "",
    password: "",
    news: 0,
    step: "form" as RegisterStep,
    signedUpWithEmail: false,
    socialToken: null,
    socialAccountType: null,
    usernameError: null,
    emailError: null,
    passwordError: null,
  }),
});

export {
  useRegister,
  guestRegister,
  willCreateAccountType,
  setProgressKey,
  setUsername,
  setEmail,
  setPassword,
  setNews,
  setStep,
  setSignedUpWithEmail,
  setSocialToken,
  setSocialAccountType,
  setUsernameError,
  setEmailError,
  setPasswordError,
  resetForm,
};
